/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import merge from 'lodash/merge';
import _mergeWith from 'lodash/mergeWith';
import defaultConfig from '../_common/js/global-config/default-config.js';
import zhCn from '../_common/js/global-config/locale/zh_CN.js';
import './type.js';

var EAnimationType = /* @__PURE__ */function (EAnimationType2) {
  EAnimationType2["ripple"] = "ripple";
  EAnimationType2["expand"] = "expand";
  EAnimationType2["fade"] = "fade";
  return EAnimationType2;
}(EAnimationType || {});
var defaultGlobalConfig = merge(defaultConfig, zhCn);
var mergeWith = function mergeWith(defaultGlobalConfig2, injectConfig) {
  return _mergeWith(defaultGlobalConfig2, injectConfig, function (objValue, srcValue) {
    if (Array.isArray(objValue)) {
      return srcValue;
    }
  });
};

export { EAnimationType, defaultGlobalConfig, mergeWith };
//# sourceMappingURL=context.js.map
